/** Visual poster themes for Ber Thong (เบอร์เงินสด) sheets — original cute skins, no licensed characters. */

export type BerThongVisualTheme = {
  id: string
  name: string
  tagline: string
  /** CSS class suffix → bt-poster--{id} */
  accent: string
  gridTone: 'light' | 'dark'
}

export const BER_THONG_VISUAL_THEMES: BerThongVisualTheme[] = [
  { id: 'sky-cloud', name: 'ฟ้าเมฆนุ่ม', tagline: 'พาสเทลฟ้า · ขอบเมฆ', accent: '#3b82f6', gridTone: 'light' },
  { id: 'blush-pink', name: 'บลัชพิงก์', tagline: 'ชมพูนุ่ม · หัวใจ', accent: '#ec4899', gridTone: 'light' },
  { id: 'mint-fresh', name: 'มินต์เฟรช', tagline: 'เขียวมิ้นต์ · สดใส', accent: '#10b981', gridTone: 'light' },
  { id: 'lavender-dream', name: 'ลาเวนเดอร์', tagline: 'ม่วงอ่อน · ฝันหวาน', accent: '#8b5cf6', gridTone: 'light' },
  { id: 'peach-sunset', name: 'พีชซันเซ็ต', tagline: 'พีช · ส้มอุ่น', accent: '#f97316', gridTone: 'light' },
  { id: 'gold-luxury', name: 'โกลด์ลักซ์', tagline: 'ดำทอง · พรีเมียม', accent: '#d4af37', gridTone: 'dark' },
  { id: 'ocean-bubble', name: 'โอเชียนบับเบิล', tagline: 'ฟ้าน้ำทะเล · ฟอง', accent: '#06b6d4', gridTone: 'light' },
  { id: 'cherry-blossom', name: 'ซากุระ', tagline: 'ชมพูดอกซากุระ', accent: '#f472b6', gridTone: 'light' },
  { id: 'forest-dew', name: 'ฟอเรสต์ดิว', tagline: 'เขียวป่า · น้ำค้าง', accent: '#059669', gridTone: 'light' },
  { id: 'candy-pop', name: 'แคนดี้ป๊อป', tagline: 'หวานฉ่ำ · สีสด', accent: '#e11d48', gridTone: 'light' },
  { id: 'midnight-star', name: 'มิดไนท์สตาร์', tagline: 'กลางคืน · ดาว', accent: '#6366f1', gridTone: 'dark' },
  { id: 'honey-bear', name: 'ฮันนี่แบร์', tagline: 'น้ำผึ้ง · อุ่นใจ', accent: '#d97706', gridTone: 'light' },
  { id: 'cotton-sky', name: 'คอตตอนสกาย', tagline: 'ขาวฟ้า · นุ่มฟู', accent: '#38bdf8', gridTone: 'light' },
  { id: 'grape-soda', name: 'เกรปโซดา', tagline: 'องุ่นซ่า · ม่วงสด', accent: '#a855f7', gridTone: 'light' },
  { id: 'lemon-zest', name: 'เลมอนเซสต์', tagline: 'เหลืองมะนาว · สดชื่น', accent: '#eab308', gridTone: 'light' },
  { id: 'coral-reef', name: 'คอรัลรีฟ', tagline: 'ปะการัง · ทะเล', accent: '#f43f5e', gridTone: 'light' },
  { id: 'rose-gold', name: 'โรสโกลด์', tagline: 'กุหลาบทอง · สุภาพ', accent: '#e11d48', gridTone: 'light' },
  { id: 'iced-mocha', name: 'ไอซ์มอคค่า', tagline: 'ครีมกาแฟ · นุ่ม', accent: '#92400e', gridTone: 'light' },
  { id: 'neon-arcade', name: 'นีออนอาร์เคด', tagline: 'มืด · สีไฟฟ้า', accent: '#22d3ee', gridTone: 'dark' },
  { id: 'snow-day', name: 'สโนว์เดย์', tagline: 'หิมะ · ฟ้าอ่อน', accent: '#64748b', gridTone: 'light' },
]

export const BER_THONG_DEFAULT_VISUAL_THEME_ID = 'sky-cloud'

export function getBerThongVisualTheme(themeId?: string | null): BerThongVisualTheme {
  const found = BER_THONG_VISUAL_THEMES.find((t) => t.id === themeId)
  return found || BER_THONG_VISUAL_THEMES[0]
}

export function isBerThongVisualThemeId(themeId: string): boolean {
  return BER_THONG_VISUAL_THEMES.some((t) => t.id === themeId)
}

/** Demo slots 00–99 for theme gallery preview (a few sold for contrast). */
export function buildBerThongPreviewSlots(soldEvery = 7) {
  return Array.from({ length: 100 }, (_, i) => {
    const number = String(i).padStart(2, '0')
    const sold = i > 0 && i % soldEvery === 0
    return {
      id: `preview-${number}`,
      number,
      status: sold ? ('sold' as const) : ('available' as const),
    }
  })
}
